import { PageLogoLayoutStyled } from "./styled";
import { Outlet } from "react-router-dom";
import { LanguageWidget } from "widgets";
import { Headers } from "components";

const PageLogoLayout = () => {
  return (
    <PageLogoLayoutStyled>
      <div className="logo_mainlayout">
        <Headers.Logo mb="0px" />
      </div>
      <div className="lang_mainlayout">
        <LanguageWidget />
      </div>
      <div className="body_mainlayout">
        <Outlet />
      </div>
    </PageLogoLayoutStyled>
  );
};

export default PageLogoLayout;
